import APIClient from '@/shared/http/clients/api'

const resourceName = 'hsm'
const APICore = process.env.APIBaseURLCore

const GetAll = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/?sort=createdAt,desc&size=500`, data, config)
const GetById = (id, config = {}) => APIClient.get(`${APICore}/${resourceName}/${id}`, config)
const GetAllPaging = (limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?sort=createdAt,desc&page=${index}&size=${limit}`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APICore}/${resourceName}/${id}`, config)

const HsmRepository = {
  GetAll,
  GetAllPaging,
  GetById,
  Create,
  Delete
}

export default HsmRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/configurations/hsm.js